module.exports = __webpack_public_path__ + "static/img/homeLogo.b158207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/latast_pc/homeLogo.png
// module id = MFoJ
// module chunks = 98